<template>
    <!-- Page Content -->
         <div id='page-wrapper'>
           <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
             <div class='container-fluid'>
                 <div class='row'>
                     <div class='col-lg-12'>
                         <h1 class='page-header'>الايصالات</h1>
                     </div>
                     <!-- /.col-lg-12 -->
                 </div>
                 <!-- /.row -->
                 <div class='row'>
                     <div class='col-lg-12'>
                         <div class='panel panel-default'>
                             <div class='panel-heading'>
                               هنا يتم عرض جميع الايصالات
                                 <div v-show="$per.value.saveTreasury" class='pull-left'>
                                 </div>
                               </div>
                                <div class='form-group col-lg-6 col-sm-6' style="padding-top:20px">
                                  <div class="form-group input-group">
                                    <span class="input-group-addon">الفرع</span>
                                    <select @change='FillItineraries()' style="padding: 0px" class="form-control" v-model="branch">
                                      <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                                      <span class="input-group-btn">
                                        <button @click='GetData()' type='button' class='btn btn-default'>
                                       عرض
                                       </button>
                                      </span>
                                  </div>
                               </div>
                               <div class='form-group col-lg-6 col-sm-6' style="padding-top:20px">
                                 <div class="form-group input-group">
                                   <span class="input-group-addon">الخط</span>
                                   <select style="padding: 0px" class="form-control" v-model="itinerary">
                                     <option v-for="item in itineraries" :key="item.id" v-bind:value="item.id">
                                       {{ item.name }}
                                     </option>
                                   </select>
                                     <span class="input-group-btn">
                                       <button @click='importRecepites()' type='button' class='btn btn-default'>
                                      استيراد للنظام الجديد
                                      </button>
                                     </span>
                                 </div>
                              </div>
                             <div class='panel-body'>
                                 <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                     <thead>
                                       <tr>
                                           <th style='text-align: center;'>م</th>
                                           <th style='text-align: center;'>الخط</th>
                                           <th style='text-align: center'>العدد</th>
                                           <th style='text-align: center'>المحصل</th>
                                           <th style='text-align: center'>آخر عمليه</th>
                                           <th style='text-align: center'>منذ</th>
                                           <th style='text-align: center'>الحالة</th>
                                           <th style='text-align: center'>الاجراء</th>
                                       </tr>
                                     </thead>
                                     <tbody>
                                         <tr class='odd gradeX' v-for='(record, index) in records' :key='record.id'>
                                           <td align ='center'>{{index + 1}}</td>
                                           <td align ='right'>{{record.name}}</td>
                                           <td align ='center'>{{record.i_count}}</td>
                                           <td align ='center' style="padding: 0px">
                                            <select @change='setCollector(record.rec_id, record.id, record.collector_id, record.name, record.i_count)' style="padding: 0px" class="form-control" v-model="record.collector_id">
                                            <option v-for="item in collectors" :key="item.id" v-bind:value="item.id">
                                                {{ item.name }}
                                            </option>
                                            </select>
                                           </td>
                                           <td align="center">
                                             <span v-if="!location || location === ''">
                                               {{ record.last_action }}
                                             </span>
                                             <span v-else>
                                               <a
                                                 :href="`https://www.google.com/maps?q=${location}`"
                                                 target="_blank"
                                                 rel="noopener noreferrer"
                                               >
                                                 {{ record.last_action }}
                                               </a>
                                             </span>
                                           </td>
                                           <td align ='center'>{{timeSince(record.updated_at)}}</td>
                                           <td align="center" :style="{ color: record.status == 0 ? 'red' : 'green' }">
                                              {{ record.status_str }}
                                          </td>
                                           <td align ='center'>
                                             <div v-if="record.rec_id > 0" class="btn-group">
                                                 <button type="button" class="btn btn-default btn-xs dropdown-toggle" data-toggle="dropdown">
                                                     مزامنة
                                                     <span class="caret"></span>
                                                 </button>
                                                 <ul class="dropdown-menu pull-left" role="menu">
                                                   <li>
                                                     <a href="javascript:void(0)" @click="mobAction(1,record.rec_id, record.collector_id)">
                                                       <i class="fa fa-refresh"></i>
                                                       مزامنة كاملة
                                                     </a>
                                                   </li>
                                                   <li>
                                                     <a href="javascript:void(0)" @click="mobAction(2,record.rec_id, record.collector_id)">
                                                       <i class="fa fa-building"></i>
                                                       مزامنة الإيصالات
                                                     </a>
                                                   </li>
                                                   <li>
                                                     <a href="javascript:void(0)" @click="mobAction(3,record.rec_id, record.collector_id)">
                                                       <i class="fa fa-th-large"></i>
                                                       مزامنة الأصناف
                                                     </a>
                                                   </li>
                                                   <li class="divider"></li>
                                                   <li>
                                                     <a href="javascript:void(0)" @click="mobAction(4,record.rec_id, record.collector_id)">
                                                       <i class="fa fa-map-marker"></i>
                                                       طلب الموقع
                                                     </a>
                                                   </li>
                                                   <li>
                                                     <a href="javascript:void(0)" @click="mobAction(5,record.rec_id, record.collector_id)">
                                                       <i class="fa fa-trash-o"></i>
                                                       مسح بيانات
                                                     </a>
                                                   </li>
                                                 </ul>
                                             </div>
                                           </td>
                                         </tr>
                                     </tbody>
                                 </table>
                                 <!-- /.table-responsive -->
                             </div>
                             <!-- /.panel-body -->
                         </div>
                         <!-- /.panel -->
                     </div>
                     <!-- /.col-lg-12 -->
                 </div>
              </div>
              <!-- /.container-fluid -->
         </div>
 </template>
<script>
import axios from 'axios'
import API from '@/store/api'
import Swal from 'sweetalert2'
export default {
  name: 'Distribution',
  data () {
    return {
      location: '',
      branches: [],
      branch: 0,
      validationErrors: '',
      records: {},
      record: {},
      title: '',
      itineraries: [],
      now: new Date(),
      itinerary: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false
    }
  },
  // =========================================================================
  mounted () {
    this.initPusher()
    this.interval = setInterval(() => {
      this.now = new Date()
    }, 60000)
  },
  // =========================================================================
  beforeDestroy () {
    clearInterval(this.interval)
    if (this.channel) {
      window.Echo.leaveChannel('distribution')
    }
  },
  // =========================================================================
  created () {
    this.GetData()
    this.branch = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.changeBranch(this.branch)
    this.FillItineraries()
  },
  methods: {
    // =========================================================================
    initPusher () {
      const pusher = new window.Pusher('187d58ce73763ac8ccfb', {
        cluster: 'eu'
      })
      const channel = pusher.subscribe('distribution')
      channel.bind('status', (data) => {
        if (data.message.action === 'ID4') {
          this.location = data.message.data
        } else {
          this.location = ''
        }
        let i = this.records.findIndex(x => parseInt(x.collector_id) === parseInt(data.message.id))
        if (i > -1) {
          this.records[i].status = data.message.status
          this.records[i].status_str = data.message.status_name
          this.records[i].updated_at = new Date().toISOString()
        }
      })
    },
    // -------------------------------------------------------
    FillItineraries () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch))
      if (i > -1) {
        this.itineraries = JSON.parse(JSON.stringify(this.branches[i].itineraries))
      }
    },
    // -------------------------------------------------------
    changeBranch () {
      this.GetData()
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
        let r = this.collectors.findIndex(r => r.id === 0)
        if (r === -1) {
          this.collectors.unshift({id: 0, name: ''})
        }
      }
    },
    // -------------------------------------------------------
    GetData () {
      this.records = []
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-invoice-distribution', {
        token: localStorage.getItem('token'),
        branch: this.branch
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // -------------------------------------------------------
    timeSince (dateString) {
      if (!dateString) {
        return '—'
      }
      const updated = new Date(dateString)
      let diff = Math.floor((this.now - updated) / 1000)

      const days = Math.floor(diff / 86400)
      diff %= 86400
      const hours = Math.floor(diff / 3600)
      diff %= 3600
      const minutes = Math.floor(diff / 60)

      const parts = []
      if (days > 0) parts.push(`${days} يوم`)
      if (hours > 0) parts.push(`${hours} ساعة`)
      if (minutes > 0) parts.push(`${minutes} دقيقة`)

      return parts.length ? `${parts.join(' و ')}` : 'الآن'
    },
    // =========================================================================
    async mobAction (id, recId, collector) {
      this.location = ''
      let i = this.records.map(record => record.rec_id).indexOf(recId)
      if (i > -1) {
        this.records[i].status_str = 'جارٍ بدء المزامنة ...'
        this.records[i].status = 0
        this.records[i].updated_at = new Date().toISOString()
      }
      try {
        const data = await API.invoiceAction(
          {
            action_id: id,
            rec_id: recId,
            collector: collector
          }
        )
        this.records[i].status = data.status
        this.records[i].last_action = data.last_action
        this.records[i].updated_at = new Date().toISOString()
      } catch (err) {
        this.validationErrors = err.errors
      }
    },
    // -------------------------------------------------------
    setCollector (recId, itinerary, collector, iName, iCount) {
      // this.isLoadingData = true
      let i = this.records.map(record => record.id).indexOf(itinerary)
      this.records[i].status = 0
      this.records[i].status_str = 'جارى اسناد الخط للمحصل'
      this.records[i].last_action = 'اسناد الخط'
      this.records[i].updated_at = new Date().toISOString()

      axios.post(this.$apiURL + 'save-invoice-distribution', {
        token: localStorage.getItem('token'),
        rec_id: recId,
        collector: collector,
        itinerary: itinerary,
        it_name: iName,
        it_count: iCount
      })
        .then(({data}) => {
          // this.isLoadingData = false
          let i = this.records.map(record => record.id).indexOf(itinerary)
          this.records[i].rec_id = data.id
          this.records[i].status = data.status
          this.records[i].status_str = data.status_str
          this.records[i].last_action = data.last_action
          this.records[i].updated_at = new Date().toISOString()
        })
        .catch(err => {
          if (err.response.status === 402) {
            let i = this.records.map(record => record.id).indexOf(itinerary)
            this.records[i].collector_id = null
            this.records[i].status = null
            this.records[i].status_str = null
            this.records[i].last_action = null
            this.records[i].updated_at = null

            Swal.fire({
              position: 'fixed',
              icon: 'error',
              title: err.response.data.errors[0],
              showConfirmButton: false,
              timer: 3000
            })
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          // this.isLoadingData = false
        })
    },
    // -------------------------------------------------------
    importRecepites () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'import-invoice', {
        token: localStorage.getItem('token'),
        itinerary: this.itinerary
      })
        .then(({ data }) => {
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Invoices/Distribution.vue